var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (!_vm.$authService.account || _vm.loggingIn)?_c('div',[_c('LoginButton',{attrs:{"redirect-url":_vm.redirectPath},on:{"login-start":function($event){_vm.loggingIn = true},"login-success":_vm.handleLogin}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }